import { createFileRoute } from "@tanstack/react-router";
import TradeInCompletion from "@/features/tradein/pages/trade-in-completion/TradeInCompletion";

export const Route = createFileRoute("/$locale/$partner/_trade-in/trade-in-completion")({
	component: TradeInCompletion,
});
